import * as R from 'ramda';
import { Form } from 'antd';
import { connect } from 'react-redux';
import { lifecycle, branch, renderComponent } from 'recompose';

import { fetchUsers } from '../../redux/thunk/users';
import { Spinner } from '../../components/ui-helpers';
import ManageUsersModalComp from './manage-users-modal-comp';
import { getUsers, getAuthorizedUser } from '../../redux/selectors';

const mapStateToProps = state => ({
  users: getUsers(state),
  authorizedUser: getAuthorizedUser(state),
});

export const ManageUsersModal = Form.create()(R.compose(
  connect(
    mapStateToProps,
    {
      fetchUsers,
    },
  ),
  lifecycle({
    componentDidMount() {
      // Fetch on open subscribe emails window
      if (!this.props.users) {
        this.props.fetchUsers();
      }
    },
  }),
  branch(
    ({ isFetching, users }) => isFetching && users.length === 0,
    renderComponent(Spinner),
  ),
)(ManageUsersModalComp));



// WEBPACK FOOTER //
// ./src/modals/manage-users-modal/manage-users-modal.js